import { ActionView } from "csi/action/ActionView";
import Controller from "csi/action/Controller";
import FormData from "csi/action/FormData";
import ViewRefConstructor, { ViewRef } from "csi/def/ViewRef";
import reflection from "csi/reflection";
import session from "csi/session";
import { ViewWidget } from "csi/view/Widget";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import declare from "dojo/_base/declare";
import ApparelBom from "../Model/ApparelBom";

const BomCompareController = declare(Controller, {
	saveResourceId: "BomCompareMenu",

	/** indicates whether or not apply the size filter */
	filterBySize: false,

	/**
     * @override
     * Select view to display (Either from Theme or Styles)
     */
	getActionView(vr: ViewRef): ActionView {
		const actionId = this.m_action.m_id;
		const isHostBOM = ApparelBom.isHostBOM(this.getParent());
		let dataSheetContainer = null;
		let dataSheetContainerPath = "Child:__Parent__/Child:__Parent__";

		if (this.getParent().$Type === "ApparelBOM") {
			dataSheetContainerPath = "Child:__Parent__";
		}

		dataSheetContainer = this.getContext().cache.getPathNode(this.getParent(), dataSheetContainerPath);

		if (dataSheetContainer?.$Type === "Style") {
			if (actionId === "ThemeBomCompare") {
				vr = new ViewRefConstructor();
				vr.m_url = this.m_urlParent;
				vr.m_id = "BOMs";
				vr.m_path = dataSheetContainerPath + "/Child:Theme";
			} else if (actionId === "StyleBomCompare") {
				vr = new ViewRefConstructor();
				vr.m_url = this.m_urlParent;
				vr.m_id = "AggregateBOMWithSamples";
				vr.m_path = dataSheetContainerPath;
			} else if (actionId === "BomCompareWithSourceBom") {
				vr = new ViewRefConstructor();
				vr.m_url = this.m_urlParent;
				vr.m_id = "LinkedSourceDataSheets";
				vr.m_path = isHostBOM ? "" : "Child:__Parent__";
			}
		} else if (dataSheetContainer?.$Type === "Theme") {
			if (actionId === "ThemeBomCompare") {
				vr = new ViewRefConstructor();
				vr.m_url = this.m_urlParent;
				vr.m_id = "AllThemeBOMs";
				vr.m_path = dataSheetContainerPath;
			} else if (actionId === "StyleBomCompare") {
				vr = new ViewRefConstructor();
				vr.m_url = this.m_urlParent;
				vr.m_id = "AggregateThemeStyleBOM";
				vr.m_path = dataSheetContainerPath;
			}
		}

		return this.inherited(arguments, [vr]);
	},

	/**
     * @override
     * return initial filters for popup view
     */
	_getViewFilters(): Element[] {
		const cache = this.getContext().cache;
		let parentBom = null;
		let dataSheetContainer = null;
		if (this.getParent().$Type === "ApparelBOM") {
			parentBom = this.getParent();
		} else if (this.getParent().$Type === "ApparelBOMRevision") {
			parentBom = cache.getPathNode(this.getParent(), "Child:__Parent__");
		}
		if (parentBom) {
			dataSheetContainer = cache.getNode(parentBom.__Parent__);
		}
		let elements = null;
		if (dataSheetContainer?.$Type === "Theme") {
			if (this.m_action.m_id === "StyleBomCompare") {
				elements = new Query()
					.RefAttr("Node Name", xml.OP_EQUALS, parentBom.$Name, "Child:StyleBOMLinkedThemeBOM")
					.RefAttr("Node Name", xml.OP_EQUALS, dataSheetContainer.$Name, "Child:__Parent__/Child:Theme")
					.getElements();
			} else if (this.m_action.m_id === "ThemeBomCompare") {
				const master = this.getContext().cache.getNode(dataSheetContainer.__Parent__);
				elements = new Query().Attr(xml.ATTR_NAME, xml.OP_EQUALS, master.$Name, "Child:__Parent__/Child:__Parent__")
					.getElements();
			}
		}
		return elements;
	},

	/**
     * @override
     * apply additional filter as needed
     */
	applyActionFilters(view: ViewWidget): void {
		if (this.filterBySize) {
			const q = new Query();
			const bomSizeSet = this.widget.get("bomSizeSet");

			if (bomSizeSet) {
				// if has size on bom
				const qOr = q.Or();
				qOr.Attr("IsTwoDim", xml.OP_EQUALS, bomSizeSet.has2dSizes(), "Child:LatestRevision/Child:BOMProductSizes/Index:0");
				qOr.Attr2("BOMProductSizes", xml.OP_EQUALS, {
					Path: reflection.PATH_LATEST_REVISION,
					Dimension: 0,
				});
			}

			view.relRoot.addQuery(q);
		}

		this.inherited(arguments);
	},

	/**
     * @override
     * Require one, and only one, selection
     */
	onFormData(fd: FormData): void {
		fd.m_bRequireOne = true;
		fd.m_bSelectOne = true;
	},

	/**
     * @override
     * Load view for selected node and augment current view with deltas
     */
	postProcessSuccess(): void {
		if (this.m_formData) {
			const node = this.m_formData.getSelectedNode();

			if (node) {
				let url = node.$URL;
				if (node.LatestRevision) {
					url = node.LatestRevision;
				}
				session.setLocationKey(session.LOCATION_COMPARE_URL, url, true);
			}
		}
	},
});

export = BomCompareController;